/**
 * Hook that provides the send message callback with WebSocket and HTTP support.
 */

import { useCallback } from 'react'
import type { SendMessageBaseParams } from './chat-message-send.interface'
import { executeSendMessage } from './chat-message-send-execute.helper'

type SendCallback = (content: string, isNote: boolean, attachmentIdList?: string[]) => Promise<void>

export const useSendMessageCallback = (params: SendMessageBaseParams): SendCallback =>
  useCallback(
    (content: string, isNote: boolean, attachmentIdList?: string[]) =>
      executeSendMessage({ content, isNote, attachmentIdList, ...params }),
    [params]
  )
